import styled from '@emotion/styled';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { tokens } from '../public/tokens';

export const SKELETON_ITEM_HEIGHT = 25;

/** Skeleton row count for course/program overview loading */
export const OVERVIEW_SKELETON_COUNT = 35;

/**
 * Calculates skeleton container height from array item count (count × 25).
 * @param {number} count - Number of skeleton rows in the original loader
 * @returns {number}
 */
export const getSkeletonHeight = (count) => count * SKELETON_ITEM_HEIGHT;

const SkeletonLoaderWrap = styled('div')`
    padding: ${({ padding }) => padding || '0px'};
    margin-bottom: ${({ $withBottomSpacing }) => ($withBottomSpacing ? tokens.globals['spacing-md'] : '0')};
    line-height: 0;
    font-size: 0;
    overflow: hidden;
    background-color: transparent;
    border: none;
    box-shadow: none;
`;

const StyledSkeleton = styled(Skeleton)`
    display: block;
    line-height: 1;
`;

/**
 * Reusable skeleton loader wrapper with calculated height.
 * @param {Object} props
 * @param {number} [props.height] - Skeleton block height in pixels
 * @param {string} [props.padding] - Container padding
 * @param {boolean} [props.withBottomSpacing] - Adds bottom spacing below loader
 * @returns {JSX.Element}
 */
const SkeletonContainer = ({ height = getSkeletonHeight(24), padding = '0px', withBottomSpacing = false }) => {
    return (
        <SkeletonLoaderWrap
            className="card skeleton-loader-wrap"
            padding={padding}
            $withBottomSpacing={withBottomSpacing}
        >
            <StyledSkeleton height={height} />
        </SkeletonLoaderWrap>
    );
};

export default SkeletonContainer;
